import type { PromptDataProfileDto } from "../../types/PromptDataProfileDto";
import type { PromptDataProfileEntity } from "../../types/PromptDataProfileEntity";

export const PromptDataProfileDtoToEntity = ({ ...rest }: Readonly<PromptDataProfileDto>): PromptDataProfileEntity => {
    return { ...rest };
};
